import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
/* import RelatedWorks from "./RelatedWorks"; */
import CustomVideoPlayer from "./CustomVideoPlayer";
import "./WorkDetail.css";

export default function FestonDetail() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
         Feston – Renewable Energy Brand Experience
        </h1>

        <p className="project-description">
         A comprehensive branding and marketing project for Feston, focused on strengthening its presence in the renewable energy industry. The project included exhibition stall design, website design, social media campaigns, corporate merchandise, and marketing collateral, creating a consistent and professional brand experience across every customer touchpoint.
        </p>
        <div className="project-tags">
          <span className="info-tag">Exhibition Design</span>
          <span className="info-tag">Marketing Collateral</span>
          <span className="info-tag">Social Media Campaigns</span>
          <span className="info-tag">Corporate Gifts</span>
        </div>
      </section>

        <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Feston/Full.webp" alt="Feston Hero Sketch" />
      </div>
       <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Feston/Full0.webp" alt="Feston Hero Sketch" />
      </div>

        <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We designed the brand logo for Feston, establishing a strong visual identity. Based on the logo we designed, we showcased it across related products and corporate collateral to ensure a unified and consistent brand presence."
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Feston/Full1.webp" alt="Feston Hero Sketch" />
      </div>
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Feston/Full2.webp" alt="Feston Hero Sketch" style={{minHeight:"925px"}}/>
      </div>
      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We designed an immersive exhibition stall for Feston that strengthens brand visibility and showcases its solar energy solutions in a professional environment. The stall combines strategic space planning, impactful product displays, and cohesive brand communication to create an engaging experience for visitors, partners, and industry professionals."
        </div>
      </section>
      {/* Three portrait videos in a row */}
      <section className="project-three-videos-section">
        <CustomVideoPlayer src="https://ascentbw.com/Images/Feston/vid1.webm" autoPlay loop muted playsInline />
        <CustomVideoPlayer src="https://ascentbw.com/Images/Feston/vid2.webm" autoPlay loop muted playsInline />
        <CustomVideoPlayer src="https://ascentbw.com/Images/Feston/Vid3.webm" autoPlay loop muted playsInline />
      </section>

       <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Feston/Full3.webp" alt="Feston Hero Sketch" />
      </div>


      <section className="project-split-images-section">
        <img src="https://ascentbw.com/Images/Feston/Half1.webp" alt="Feston Living Room" />
        <img src="https://ascentbw.com/Images/Feston/Half2.webp" alt="Feston Materials" />
      </section>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We created high-impact social media campaigns to promote Feston's products, exhibitions, and industry events. The designs focused on increasing brand awareness, driving engagement, and maintaining a consistent visual identity across digital platforms while effectively communicating key product offerings."
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Feston/Full4.webp" alt="Feston Brand Exhibition" />
      </div>

        <section className="project-split-images-section">
        <img src="https://ascentbw.com/Images/Feston/Half3.webp" alt="Feston Living Room" />
        <img src="https://ascentbw.com/Images/Feston/Half4.webp" alt="Feston Materials" />
      </section>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We developed a collection of branded merchandise, including mouse pads, shopping bags, and promotional materials, to extend Feston's brand presence beyond digital and event touchpoints. Each item was designed to reinforce brand recognition while delivering a professional and consistent visual experience."
        </div>
      </section>

        <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Feston/Full5.webp" alt="Feston Brand Exhibition" />
      </div>

        <section className="project-split-images-section">
        <img src="https://ascentbw.com/Images/Feston/Half5.webp" alt="Feston Living Room" />
        <img src="https://ascentbw.com/Images/Feston/Half6.webp" alt="Feston Materials" />
      </section>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We designed custom promotional products such as branded mugs and keychains to enhance customer engagement and strengthen brand recall. These assets were crafted to reflect Feston's visual identity while serving as practical and memorable brand touchpoints."
        </div>
      </section>
      {/* <RelatedWorks excludePath="/works/feston" /> */}
      <Footer />
    </div>
  );
}
